import React from "react";

function TermsPage() {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="bg-white p-8 rounded-lg shadow-lg w-3/4 mt-12">
                <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
                <div className="space-y-4 text-gray-700 text-sm">
                    <p><strong>Last Updated: May 2025</strong></p>
                    <p>
                        Welcome to juza.pro (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;). By accessing or using our website and services, including event guest lists, invitations, and related event management tools (collectively, the &quot;Services&quot;), you agree to comply with and be bound by these Terms and Conditions (&quot;Terms&quot;). If you do not agree to these Terms, please do not use our Services.
                    </p>
                    
                    <p><strong>1. Eligibility</strong></p>
                    <p>
                        By using juza.pro, you represent that you are at least 18 years old or have reached the age of majority in your jurisdiction, and have the legal authority to enter into this agreement.
                    </p>

                    <p><strong>2. Account Registration</strong></p>
                    <ul className="list-disc list-inside">
                        <li>To use certain features, you must register an account and provide accurate, complete information.</li>
                        <li>You are responsible for maintaining the confidentiality of your account and password.</li>
                        <li>You agree to notify us immediately of any unauthorized use of your account.</li>
                    </ul>

                    <p><strong>3. Use of Services</strong></p>
                    <ul className="list-disc list-inside">
                        <li>juza.pro provides event organizers with tools to manage guest lists, send invitations, and process event admissions.</li>
                        <li>You may not use the Service for any unlawful purpose, or to infringe the rights of others.</li>
                        <li>You agree not to misuse, copy, or resell any part of the Service without our written permission.</li>
                    </ul>

                    <p><strong>4. Data Privacy</strong></p>
                    <ul className="list-disc list-inside">
                        <li>By using our Service, you consent to the collection and use of information as described in our Privacy Policy.</li>
                        <li>You are responsible for the data you upload, including personal data of guests or invitees. You agree to comply with applicable data protection laws when using our Service.</li>
                    </ul>

                    <p><strong>5. Fees and Payments</strong></p>
                    <ul className="list-disc list-inside">
                        <li>Certain features of juza.pro may require payment. All fees are specified on the website and are subject to change.</li>
                        <li>Payments are processed via secure third-party providers. By providing payment information, you authorize us to process charges as described.</li>
                    </ul>

                    <p><strong>6. Intellectual Property</strong></p>
                    <ul className="list-disc list-inside">
                        <li>All content, software, and technology on juza.pro are owned by or licensed to us.</li>
                        <li>You may not copy, modify, distribute, or create derivative works from our content without our express permission.</li>
                    </ul>

                    <p><strong>7. Termination</strong></p>
                    <ul className="list-disc list-inside">
                        <li>We reserve the right to suspend or terminate your account at any time if you violate these Terms or use the Service inappropriately.</li>
                        <li>Upon termination, your right to use the Services will immediately cease.</li>
                    </ul>

                    <p><strong>8. Disclaimers and Limitation of Liability</strong></p>
                    <ul className="list-disc list-inside">
                        <li>The Service is provided &quot;as is&quot; and without warranties of any kind.</li>
                        <li>We are not liable for any damages arising from your use of juza.pro, including but not limited to loss of data, profit, or business.</li>
                    </ul>

                    <p><strong>9. Changes to Terms</strong></p>
                    <ul className="list-disc list-inside">
                        <li>We may update these Terms from time to time. Changes will be effective upon posting on this page.</li>
                        <li>Continued use of the Service after changes constitutes your acceptance of the new Terms.</li>
                    </ul>

                    <p><strong>10. Governing Law</strong></p>
                    <ul className="list-disc list-inside">
                        <li>These Terms are governed by the laws of [Your Country / Jurisdiction].</li>
                        <li>Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts of [Your Country / Jurisdiction].</li>
                    </ul>

                    <p><strong>11. Contact</strong><br/>
                        If you have any questions about these Terms, please contact us at:<br />
                        <a href="mailto:support@juza.pro" className="text-blue-500 underline">support@juza.pro</a>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default TermsPage;
